import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  InputAdornment,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GerenerateIcon from "../../../Custom-imeges/GerenerateIcon";
import { PromoDropdown } from "../Components/PromoDropdown";
import {
  DurationDropdownItems,
  PromoAlertData,
  SubscriptionType,
  PromotionDropdownItems,
} from "../../../Helper";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  useCreatePromoCode,
  useGeneratePromoCode,
} from "../../../store/Apis/StripeApi";
import dayjs, { Dayjs } from "dayjs";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { setSnackBarAlert } from "../../../store/one-query/chatsSlice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "../../Views/promoCode.css";

export const inputStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  backgroundColor: "transparent",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "#2B3544",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    lineHeight: "1.5",
    padding: "10px",

    "&::placeholder": {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "14px",
    },
    color: "var(--Main_icons_color)",
    caretColor: "#12B6EA",
  },
  "& .MuiInputBase-input::-webkit-scrollbar": {
    width: "5px",
  },
  "& .MuiInputBase-input::-webkit-scrollbar-thumb": {
    backgroundColor: "var(--sub_background4)",
    borderRadius: "8px",
  },
};

export const CheckboxStyle = {
  color: "var(--Main_icons_color)",
  "&.Mui-checked": {
    color: "#12B6EA",
  },
  "&:hover": {
    backgroundColor: "transparent",
  },
};

export const SecInputStyles = {
  width: "60%",
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  color: "var(--Main_icons_color)",
  backgroundColor: "#2B3544",
  borderRadius: "8px",
  maxHeight: "40px",
  height: "40px",
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    "& input": {
      fontSize: "12px",
      height: "40px",
      padding: "0 12px",
      color: "var(--Main_icons_color)",
      opacity: "0.5",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    height: "40px",
    padding: "0 12px",
    color: "var(--Main_icons_color)",
    textTransform: "uppercase",
  },
  "& .MuiInputAdornment-root": {
    color: "var(--Main_icons_color)",
  },
};
interface CreatePromoCodeProps {
  promoAlert: PromoAlertData;
  setPromoAlert: (data: PromoAlertData) => void;
}
export const CreatePromoCode = ({
  setPromoAlert,
  promoAlert,
}: CreatePromoCodeProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    mutate: CreatePromoCodeRequest,
    isPending,
    isSuccess: isCreatePromoCodeSuccess,
    error: CreatePromoCodeError,
  } = useCreatePromoCode();
  const [generateCodeId, setGenerateCodeId] = useState(false);
  const {
    refetch: GeneratePromoCodeID,
    data: GeneratedCodeId,
    isSuccess: isGenerateIdSuccess,
  } = useGeneratePromoCode();
  const [checkboxState, setCheckboxState] = useState({
    usageLimit: false,
    singleUsePerUser: false,
    onlyNewUsers: false,
    specificCustomer: false,
  });

  const [promoFormErrors, setPromoFormErrors] = useState({
    codeId: {
      isError: false,
      errorMsg: "",
    },
    codeName: {
      isError: false,
      errorMsg: "",
    },
    promotion: {
      isError: false,
      errorMsg: "",
    },
    specificUserInput: {
      isError: false,
      errorMsg: "",
    },
  });

  const [promoFormInputs, setPromoFormInputs] = useState({
    codeId: "",
    codeName: "",
    description: "",
    promotion: {
      type: "",
      discount: 0,
      amount: 0,
    },
    duration: {
      type: "",
      months: 0,
    },
    expirationDate: null as Dayjs | null,
    limitationTimes: 0,
    specificUser: {
      isAdded: false,
      user: "",
    },
    subscriptionType: "",
  });

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  useEffect(() => {
    if (isCreatePromoCodeSuccess) {
      setPromoFormInputs({
        codeId: "",
        codeName: "",
        description: "",
        promotion: {
          type: "",
          discount: 0,
          amount: 0,
        },
        duration: {
          type: "",
          months: 1,
        },
        expirationDate: null,
        limitationTimes: 1,
        specificUser: {
          isAdded: false,
          user: "",
        },
        subscriptionType: "",
      });
      setCheckboxState({
        usageLimit: false,
        singleUsePerUser: false,
        onlyNewUsers: false,
        specificCustomer: false,
      });
      setPromoFormErrors({
        codeId: {
          isError: false,
          errorMsg: "",
        },
        codeName: {
          isError: false,
          errorMsg: "",
        },
        promotion: {
          isError: false,
          errorMsg: "",
        },
        specificUserInput: {
          isError: false,
          errorMsg: "",
        },
      });
      navigate("/admin/manage-coupons");
      dispatch(
        setSnackBarAlert({
          show: true,
          message: "Promo-code created successfully",
          alertType: "success",
        })
      );
    }
    if (CreatePromoCodeError && !isCreatePromoCodeSuccess) {
      let errorMessage: any;
      errorMessage = (CreatePromoCodeError as any)?.response?.data;
      if (typeof errorMessage === "string") {
        if (
          errorMessage.toLowerCase().includes("amount") ||
          errorMessage.toLowerCase().includes("percentoff")
        ) {
          setPromoFormErrors((prevErrors) => ({
            ...prevErrors,
            promotion: {
              isError: true,
              errorMsg: errorMessage,
            },
          }));
        } else if (errorMessage.toLowerCase().includes("exists")) {
          setPromoFormErrors((prevErrors) => ({
            ...prevErrors,
            codeId: {
              isError: true,
              errorMsg: errorMessage,
            },
          }));
        }
      } else {
        errorMessage = (CreatePromoCodeError as any)?.response?.data.error
          ?.message;
        if (typeof errorMessage === "string") {
          if (errorMessage.toLowerCase().includes("exists")) {
            setPromoFormErrors((prevErrors) => ({
              ...prevErrors,
              codeId: {
                isError: true,
                errorMsg: errorMessage,
              },
            }));
          }
        }
      }
    }
  }, [isCreatePromoCodeSuccess, CreatePromoCodeError]);

  const handleGenerateCodeId = () => {
    setGenerateCodeId(true);
    GeneratePromoCodeID();
  };

  useEffect(() => {
    if (generateCodeId && GeneratedCodeId) {
      setPromoFormInputs((prevState) => ({
        ...prevState,
        codeId: "",
      }));
      setPromoFormInputs((prevState) => ({
        ...prevState,
        codeId: GeneratedCodeId,
      }));
      setGenerateCodeId(false);
    }
  }, [generateCodeId, GeneratedCodeId]);

  const handleCreatePromoCodeRequest = () => {
    if (
      promoFormInputs.codeId &&
      promoFormInputs.codeName &&
      promoFormInputs.promotion.type &&
      promoFormInputs.duration.type
    ) {
      let PromoCodeData = {
        code: promoFormInputs.codeId.replace(/\s+/g, ""),
        codeName: promoFormInputs.codeName.replace(/\s+/g, ""),
        description: promoFormInputs.description,
        customerEmail: promoFormInputs.specificUser.user,
        promotionType: PromotionDropdownItems.indexOf(
          promoFormInputs.promotion.type
        ),
        percentOff:
          promoFormInputs.promotion.discount > 0
            ? promoFormInputs.promotion.discount
            : undefined,
        amountOff:
          promoFormInputs.promotion.amount > 0
            ? promoFormInputs.promotion.amount
            : undefined,
        durationInmonths: promoFormInputs.duration.months
          ? promoFormInputs.duration.months
          : undefined,
        duration: DurationDropdownItems.indexOf(promoFormInputs.duration.type),
        expirationDate: promoFormInputs.expirationDate
          ? promoFormInputs.expirationDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          : undefined,
        usageLimit: promoFormInputs.limitationTimes,
        subscriptionType: SubscriptionType.indexOf(promoFormInputs.subscriptionType),
      };
      CreatePromoCodeRequest(PromoCodeData);
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxState({
      ...checkboxState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleCodeIdInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      codeId: event.target.value,
    }));
  };

  const handleCodeNameInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      codeName: event.target.value,
    }));
  };

  const handleDescriptionInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      description: event.target.value,
    }));
  };

  const handlePromotionInputChange = (item: string) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      promotion: {
        ...prevState.promotion,
        type: item,
      },
    }));
  };

  const handleDurationInputChange = (item: string) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      duration: {
        ...prevState.duration,
        type: item,
      },
    }));
  };

  const handleDateChange = (newDate: Dayjs | null) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      expirationDate: newDate,
    }));
  };

  const handleCodePlanChange = (plan: string) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      subscriptionType: plan,
    }));
  };

  const handleLimitationTimesInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const numericValue = event.target.value.replace(/\D/g, "");

    setPromoFormInputs((prevState) => ({
      ...prevState,
      limitationTimes: numericValue ? Number(numericValue) : 0,
    }));
  };

  const handleSpecificUserInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = event.target.value;

    setPromoFormInputs((prevState) => ({
      ...prevState,
      specificUser: {
        ...prevState.specificUser,
        user: inputValue,
      },
    }));
  };

  const handleAddSpecificUser = () => {
    // Regex patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const namePattern = /^[a-zA-Z\s'-]{2,50}$/;
    if (promoFormInputs.specificUser) {
      if (
        emailPattern.test(promoFormInputs.specificUser.user) ||
        namePattern.test(promoFormInputs.specificUser.user)
      ) {
        setPromoFormErrors((prevErrors) => ({
          ...prevErrors,
          specificUserInput: {
            isError: false,
            errorMsg: "",
          },
        }));
        setPromoFormInputs((prevState) => ({
          ...prevState,
          specificUser: {
            ...prevState.specificUser,
            isAdded: true,
          },
        }));
      } else {
        setPromoFormErrors((prevErrors) => ({
          ...prevErrors,
          specificUserInput: {
            isError: true,
            errorMsg: "Invalid email or name format",
          },
        }));
      }
    }
  };

  const handleMonthsOfDurationInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let numericValue = event.target.value.replace(/\D/g, "");
    let numValue = Number(numericValue);

    // Ensure the value stays between 1 and 12
    if (numValue > 12) numValue = 12;
    if (numValue < 1 && numericValue !== "") numValue = 1;

    setPromoFormInputs((prevState) => ({
      ...prevState,
      duration: {
        ...prevState.duration,
        months: numericValue ? numValue : 0, // Ensure months is always a number
      },
    }));
  };

  const handleSecInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = event.target.value.replace(/\D/g, "");

    setPromoFormInputs((prevState) => ({
      ...prevState,
      promotion: {
        ...prevState.promotion,
        amount:
          prevState.promotion.type === "Flat Amount Off"
            ? Number(numericValue) || 0
            : 0,
        discount:
          prevState.promotion.type === "Percentage Off"
            ? Number(numericValue) || 0
            : 0,
      },
    }));
  };

  const secInputValue =
    promoFormInputs.promotion.type === "Percentage Off"
      ? promoFormInputs.promotion.discount
      : promoFormInputs.promotion.amount;

  const handleCancelCreatePromo = () => {
    navigate("/admin/manage-coupons");
  };

  const handleRemoveSpecificUser = () => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      specificUser: {
        isAdded: false,
        user: "",
      },
    }));
  };
  return (
    <Box className="promoCode-body-container">
      <Box className="promoCode-body-header">
        <Box className="heder-Content">
          <Typography className="page-header-main-title">
            New promo code
          </Typography>
          <Typography className="page-header-subtitle">
            Promo codes can be used to discount invoices, subscriptions, or
            entire customer accounts.
          </Typography>
        </Box>
        <Box className="RegisterOrSignIn">
          <Box className="buttons">
            <button
              className="signInBtn cancel-promoCode-changes"
              onClick={handleCancelCreatePromo}
            >
              <span>Cancel</span>
            </button>

            <button
              className="registerBtn save-promoCode-changes"
              onClick={handleCreatePromoCodeRequest}
            >
              <span>Save</span>
            </button>
          </Box>
        </Box>
      </Box>
      <Box className="promoCode-body-content">
        <Box className="promoCode-body-left-side">
          <Box className="codeId box">
            <Box className="box-titles">
              <Typography className="box-title">Code ID *</Typography>
            </Box>
            <Box className="inputs-box">
              <TextField
                maxRows={1}
                sx={{
                  ...inputStyles,
                  width: "60%",
                  minWidth: "350px !important",
                }}
                value={promoFormInputs.codeId}
                onChange={handleCodeIdInputChange}
                error={promoFormErrors.codeId.isError}
                helperText={promoFormErrors.codeId.errorMsg}
              />
              {promoFormInputs.codeId.length === 0 ? (
                <button
                  className={`generate-btn`}
                  style={{ height: "100%" }}
                  onClick={handleGenerateCodeId}
                >
                  <GerenerateIcon />
                  <span>Generate ID</span>
                </button>
              ) : null}
            </Box>
          </Box>
          <Box className="codeName box">
            <Box className="box-titles">
              <Typography className="box-title">Code Name *</Typography>
              <Typography className="box-description">
                Select a unique code, that only contains alphanumeric
                characters.
              </Typography>
            </Box>
            <Box className="inputs-box">
              <TextField
                value={promoFormInputs.codeName}
                onChange={handleCodeNameInputChange}
                maxRows={1}
                sx={{
                  ...inputStyles,
                  width: "60%",
                  minWidth: "350px !important",
                }}
              />
            </Box>
          </Box>
          <Box className="description box">
            <Typography className="box-title">Description</Typography>
            <Box className="inputs-box">
              <TextField
                multiline
                maxRows={2}
                minRows={2}
                value={promoFormInputs.description}
                onChange={handleDescriptionInputChange}
                sx={{
                  ...inputStyles,
                  width: "60%",
                  minWidth: "350px !important",
                  "& .MuiInputBase-input": {
                    padding: "0",
                    color: "#fff",
                    caretColor: "#12B6EA",
                  },
                }}
              />
            </Box>
          </Box>
          <Box className="promotion box">
            <Box className="box-title">
              <Typography className="box-title">Promotion Type *</Typography>
              <Typography className="box-description">
                Select type of promotion.{" "}
              </Typography>
              <Box className="inputs-box">
                <PromoDropdown
                  width="60%"
                  selectedItem={promoFormInputs.promotion.type}
                  handleSelect={handlePromotionInputChange}
                  dropdownItems={PromotionDropdownItems}
                  defaultRenderValue="Select value"
                />
                {promoFormInputs.promotion.type === "Percentage Off" ||
                promoFormInputs.promotion.type === "Flat Amount Off" ||
                promoFormInputs.promotion.type === "Limited Time" ? (
                  <Box
                    sx={{
                      width: "40%",
                      position: "absolute",
                      top: "-25px",
                      right: "-3rem",
                    }}
                  >
                    <Typography
                      className="box-title"
                      sx={{ paddingBottom: "4px" }}
                    >
                      Discount *
                    </Typography>
                    <FormControl
                      sx={{ width: "92%" }}
                      error={promoFormErrors.promotion.isError}
                    >
                      <OutlinedInput
                        value={secInputValue}
                        onChange={handleSecInputChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <Typography className="secInputLabel">
                              Off
                            </Typography>
                          </InputAdornment>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{ ...SecInputStyles }}
                        error={promoFormErrors.promotion.isError}
                      />

                      {promoFormErrors.promotion.isError && (
                        <FormHelperText sx={{ mx: 0 }}>
                          {promoFormErrors.promotion.errorMsg}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box className="duration box position-relative">
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box className="box-title">
                <Typography className="box-title">Duration *</Typography>
                <Typography className="box-description">
                  This determines how long this coupon will apply once redeemed.
                </Typography>
              </Box>
              <Box className="inputs-box">
                <PromoDropdown
                  width="60%"
                  selectedItem={promoFormInputs.duration.type}
                  handleSelect={handleDurationInputChange}
                  dropdownItems={DurationDropdownItems}
                  defaultRenderValue="Select duration"
                />
              </Box>
            </Box>
            {promoFormInputs.duration.type === "Multiple months" ? (
              <Box
                sx={{
                  width: "40%",
                  position: "absolute",
                  top: "25px",
                  right: "-3rem",
                }}
              >
                <Typography className="box-title" sx={{ padding: "0 0 5px 0" }}>
                  Number of months
                </Typography>

                <OutlinedInput
                  value={promoFormInputs.duration.months}
                  onChange={handleMonthsOfDurationInputChange}
                  endAdornment={
                    <InputAdornment position="end">
                      <Typography className="secInputLabel">Month</Typography>
                    </InputAdornment>
                  }
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  sx={{ ...SecInputStyles, width: "55%" }}
                />
              </Box>
            ) : null}
          </Box>
          <Box className="expiration box">
            <Box className="box-title">
              <Typography className="box-title">Expiration date</Typography>
            </Box>
            <Box className="inputs-box position-relative">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["SingleInputDateRangeField"]}
                  sx={{ width: "60%", minWidth: "350px !important" }}
                >
                  <DatePicker
                    value={promoFormInputs.expirationDate}
                    onChange={handleDateChange}
                    shouldDisableDate={(date) => date.isBefore(dayjs(), "day")}
                    sx={{
                      ...SecInputStyles,
                      width: "100%",
                      "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                        color: "var(--Main_icons_color)",
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {promoFormInputs.expirationDate && (
                <Box
                  className="expired-clock"
                  sx={{ position: "absolute", left: "15%", top: "29%" }}
                >
                  <Typography className="expired-clock-text">
                    11:59 PM
                  </Typography>
                  <AccessTimeIcon sx={{ fontSize: "1rem" }} />
                </Box>
              )}
            </Box>
          </Box>
          <Box className="promocode-plane box position-relative">
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box className="box-title">
                <Typography className="box-title">Subscription Type</Typography>
                <Typography className="box-description">
                  Select whether this promo code applies to monthly or annually.
                </Typography>
              </Box>
              <Box className="inputs-box">
                <PromoDropdown
                  width="60%"
                  selectedItem={promoFormInputs.subscriptionType}
                  handleSelect={handleCodePlanChange}
                  dropdownItems={SubscriptionType}
                  defaultRenderValue="Select subscription type"
                />
              </Box>
            </Box>
          </Box>
          <Box className="select-option limitation-box">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                {...label}
                sx={CheckboxStyle}
                name="usageLimit"
                checked={checkboxState.usageLimit}
                onChange={handleCheckboxChange}
              />
              <Typography className="select-option-text">
                Limit the number of time this code can be used.{" "}
              </Typography>
            </Box>
            {checkboxState.usageLimit ? (
              <OutlinedInput
                value={promoFormInputs.limitationTimes}
                onChange={handleLimitationTimesInputChange}
                endAdornment={
                  <InputAdornment position="end">
                    <Typography className="secInputLabel">Times</Typography>
                  </InputAdornment>
                }
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                  "aria-label": "weight",
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                sx={{ ...SecInputStyles, marginLeft: "10px", width: "52%" }}
              />
            ) : null}
          </Box>
          <Box className="select-option">
            <Checkbox
              {...label}
              sx={CheckboxStyle}
              name="singleUsePerUser"
              onChange={handleCheckboxChange}
              defaultChecked
            />
            <Typography className="select-option-text">
              Customers can only use this promo code once.{" "}
            </Typography>
          </Box>
          <Box className="select-option">
            <Checkbox
              {...label}
              sx={CheckboxStyle}
              name="onlyNewUsers"
              checked={checkboxState.onlyNewUsers}
              onChange={handleCheckboxChange}
            />
            <Typography className="select-option-text">
              Only new subscribers can use this promo code.{" "}
            </Typography>
          </Box>
          <Box className="select-option limitation-box">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                {...label}
                sx={CheckboxStyle}
                name="specificCustomer"
                checked={checkboxState.specificCustomer}
                onChange={handleCheckboxChange}
              />
              <Typography className="select-option-text">
                Limit to a specific customer.{" "}
              </Typography>
            </Box>
            {checkboxState.specificCustomer &&
            !promoFormInputs.specificUser.isAdded ? (
              <FormControl
                sx={{ width: "100%" }}
                error={promoFormErrors.specificUserInput.isError}
              >
                <OutlinedInput
                  placeholder="Enter Customer email or Name"
                  value={promoFormInputs.specificUser.user}
                  onChange={handleSpecificUserInputChange}
                  endAdornment={
                    promoFormInputs.specificUser.user ? (
                      <InputAdornment position="end">
                        <Typography
                          className="secInputLabelAdd"
                          onClick={handleAddSpecificUser}
                        >
                          Add
                        </Typography>
                      </InputAdornment>
                    ) : null
                  }
                  aria-describedby="outlined-weight-helper-text"
                  sx={{
                    ...SecInputStyles,
                    marginLeft: "10px",
                    paddingLeft: "1rem",
                    width: "52%",
                    "& .MuiInputBase-input": {
                      textTransform: "inherit",
                    },
                  }}
                  error={promoFormErrors.specificUserInput.isError}
                />

                {promoFormErrors.specificUserInput.isError && (
                  <FormHelperText sx={{ mx: 0 }}>
                    {promoFormErrors.specificUserInput.errorMsg}
                  </FormHelperText>
                )}
              </FormControl>
            ) : (
              promoFormInputs.specificUser.isAdded &&
              promoFormInputs.specificUser.user && (
                <Box
                  className="user"
                  sx={{
                    width: "52%",
                    marginLeft: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box className="user-name">
                    {promoFormInputs.specificUser.user}
                  </Box>
                  <Box
                    className="remove-name c-pointer"
                    onClick={handleRemoveSpecificUser}
                  >
                    Remove
                  </Box>
                </Box>
              )
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
